export { Contact as default } from "./contact";
